const DashboardIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.74994 1.9H9.24994C9.79341 1.9 10.1001 2.28879 10.1001 2.60411V6.72911C10.1001 7.04466 9.79335 7.43339 9.24994 7.43339H1.74994C1.20678 7.43339 0.9 7.04472 0.9 6.72911V2.60411C0.9 2.28873 1.20671 1.9 1.74994 1.9Z"
        stroke="var(--primary)"
        strokeWidth="1.8"
      />
      <path
        d="M1.74994 11.0665H9.24994C9.79335 11.0665 10.1001 11.4552 10.1001 11.7708V21.3958C10.1001 21.7111 9.79341 22.0999 9.24994 22.0999H1.74994C1.20671 22.0999 0.9 21.7112 0.9 21.3958V11.7708C0.9 11.4552 1.20678 11.0665 1.74994 11.0665Z"
        stroke="var(--primary)"
        strokeWidth="1.8"
      />
      <path
        d="M14.7501 16.5665H22.2501C22.7933 16.5665 23.1001 16.9552 23.1001 17.2708V21.3958C23.1001 21.7112 22.7933 22.0999 22.2501 22.0999H14.7501C14.2066 22.0999 13.9 21.7111 13.9 21.3958V17.2708C13.9 16.9552 14.2067 16.5665 14.7501 16.5665Z"
        stroke="var(--primary)"
        strokeWidth="1.8"
      />
      <path
        d="M21.3501 1.9H22.2501C22.7933 1.9 23.1001 2.28873 23.1001 2.60411V12.2291C23.1001 12.5447 22.7933 12.9334 22.2501 12.9334H14.7501C14.2067 12.9334 13.9 12.5447 13.9 12.2291V2.60411C13.9 2.28879 14.2066 1.9 14.7501 1.9H21.3501Z"
        stroke="var(--primary)"
        strokeWidth="1.8"
      />
    </svg>
  );
};

export default DashboardIcon;
